import React, { useState } from 'react';
import { Copy, Download, Printer } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { codesAlsText, DRUCK_BLOCKIERT } from '../../lib/zweiFaktor';

const DATEINAME = 'TimeNYzer-Wiederherstellungscodes.txt';

export const CodesAnzeige = ({ codes, konto, onFertig, fertigText = 'Fertig' }) => {
  const [aufbewahrt, setAufbewahrt] = useState(false);
  const text = codesAlsText(codes, konto);

  const kopieren = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success('Codes kopiert');
    } catch {
      toast.error('Kopieren hat nicht geklappt. Bitte speichern Sie die Codes als Textdatei.');
    }
  };

  const speichern = () => {
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = DATEINAME;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  // Ohne noopener: sonst liefert window.open immer null. Inhalt nur als textContent.
  const drucken = () => {
    const fenster = window.open('', '_blank');
    if (!fenster) {
      toast.error(DRUCK_BLOCKIERT);
      return;
    }
    const pre = fenster.document.createElement('pre');
    pre.textContent = text;
    fenster.document.title = 'TimeNYzer – Wiederherstellungscodes';
    fenster.document.body.appendChild(pre);
    fenster.focus();
    fenster.print();
  };

  return (
    <div className="space-y-4" data-testid="zwei-faktor-codes">
      <p className="text-sm text-slate-700">Mit diesen Codes kommen Sie hinein, wenn Ihr Handy weg ist. Jeder Code funktioniert genau einmal.</p>
      <div className="grid grid-cols-2 gap-2 rounded-lg border bg-slate-50 p-3" data-testid="zwei-faktor-codes-liste">
        {(codes || []).map((c) => <code key={c} className="font-mono text-sm text-slate-900">{c}</code>)}
      </div>
      <div className="flex flex-wrap gap-2">
        <Button type="button" variant="outline" size="sm" onClick={kopieren} data-testid="zwei-faktor-codes-kopieren"><Copy className="mr-2 h-4 w-4" />Kopieren</Button>
        <Button type="button" variant="outline" size="sm" onClick={speichern} data-testid="zwei-faktor-codes-speichern"><Download className="mr-2 h-4 w-4" />Als Textdatei speichern</Button>
        <Button type="button" variant="outline" size="sm" onClick={drucken} data-testid="zwei-faktor-codes-drucken"><Printer className="mr-2 h-4 w-4" />Drucken</Button>
      </div>
      <label className="flex items-start gap-2 text-sm text-slate-700">
        <Checkbox checked={aufbewahrt} onCheckedChange={(v) => setAufbewahrt(v === true)} data-testid="zwei-faktor-codes-aufbewahrt" />
        <span>Ich habe die Codes sicher aufbewahrt (nicht im WhatsApp-Chat)</span>
      </label>
      <Button type="button" className="w-full bg-blue-800 hover:bg-blue-900" disabled={!aufbewahrt} onClick={onFertig} data-testid="zwei-faktor-fertig">
        {fertigText}
      </Button>
    </div>
  );
};

export default CodesAnzeige;
